import React from "react";
import { Nav, Card, Loader, FormSelect, Button } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import * as XLSX from "xlsx";

import AuthContext from "../../../context/AuthContext";
import DataTable from "../../../components/statistics/statistics-general/DataTable";

import axiosConfig from "../../../utils/axiosConfig";

import {
  repairTimeTable,
  totalLossTimeTable,
  techniqueTable,
  avgCostTable,
} from "./dataAbeille";

export default class StatisticsAbeille extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      year: new Date().getFullYear(),
      yearSelect: [
        {
          value: new Date().getFullYear(),
          text: `${new Date().getFullYear() - 1} - ${new Date().getFullYear()}`,
        },
      ],
      group: "DEFAULT",
      groupSelect: [{ value: "DEFAULT", text: "Tous les groupes" }],
      data: null,
      search: null,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    this.getYearSelect();
    this.getGroupSelect();
    this.getPerformance();
  }

  getYearSelect = () => {
    axiosConfig("statistics/general/get-years-options").then((res) => {
      if (res.data.success) {
        this.setState({ yearSelect: res.data.data });
      } else {
        const year = new Date().getFullYear();
        this.setState({
          yearSelect: [{ value: year, text: `${year - 1} - ${year}` }],
        });
      }
    });
  };

  getGroupSelect = () => {
    this.setState({
      group: "DEFAULT",
      groupSelect: [
        { value: "DEFAULT", text: "Tous les groupes" },
        { value: 22, text: "LANG" },
      ],
    });
  };

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: Number(value) }, () => {
      if (name !== "group") this.getPerformance();
    });
  };

  getPerformance = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig({
        url: "pilotage-cabinet/company-performance/statistics-abeille",
        data: {
          year: this.state.year,
          // groupId: this.state.group && this.state.group !== "DEFAULT" ? this.state.group : null
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.getTables(res.data.data, () => {
              this.setState({
                search: res.data.search,
                isLoad: false,
              });
            });
          } else {
            this.setState({ data: null, isLoad: false });
          }
        })
        .catch(() => {
          this.setState({ isLoad: false }, () =>
            alert("Une erreur est survenue")
          );
        });
    });
  };

  getTables = (data, callback) => {
    const tables = [
      repairTimeTable,
      totalLossTimeTable,
      techniqueTable,
      avgCostTable,
    ];

    const tablesData = tables.map((table) => {
      const tableData = table.map((row) => ({
        id: row.id,
        name: row.name,
        data: this.getData(data[row.id]),
        unit: row.unit,
        title: row.title,
        evolReversed: row.evolReversed,
      }));
      return tableData;
    });

    this.setState({ data: tablesData }, () => callback());
  };

  getData = (rawData) => {
    return rawData.map((el, idx) => {
      if ((idx + 2) % 3 === 0) {
        return this.getEvolution(rawData[idx - 1], rawData[idx + 1]);
      } else {
        return el;
      }
    });
  };

  getEvolution = (current, old) => {
    let diff = 0;

    if (!old && !current) {
      diff = 0;
    } else if (!old) {
      diff = 100;
    } else if (!current) {
      diff = 100;
    } else {
      diff = parseInt(((old - current) / current) * 100);
    }

    if (diff > 0) {
      return "+" + diff;
    } else {
      return diff;
    }
  };

  exportExcel = () => {
    if (!this.state.data || this.state.data.length === 0) {
      alert("Aucune donnée à exporter");
      return;
    }

    const year = this.state.year;
    const sheetTitles = [
      "Délais réparation",
      "Délais perte totale",
      "Technique",
      "Coût Moyen",
    ];

    // Each indicator row holds 51 values grouped 3-by-3 (N-1, Evol. N-1, N)
    // following the same period order as the on-screen table.
    const periods = [
      { label: `${year - 1} / ${year}`, base: 0 },
      { label: "Janvier", base: 3 },
      { label: "Février", base: 6 },
      { label: "Mars", base: 9 },
      { label: "T1", base: 12 },
      { label: "Avril", base: 15 },
      { label: "Mai", base: 18 },
      { label: "Juin", base: 21 },
      { label: "T2", base: 24 },
      { label: "Juillet", base: 27 },
      { label: "Août", base: 30 },
      { label: "Septembre", base: 33 },
      { label: "T3", base: 36 },
      { label: "Octobre", base: 39 },
      { label: "Novembre", base: 42 },
      { label: "Décembre", base: 45 },
      { label: "T4", base: 48 },
    ];

    const workBook = XLSX.utils.book_new();

    this.state.data.forEach((table, tableIdx) => {
      // Group header row : "Indicateur", "Unité" then one label spanning 3 cols.
      const headerGroup = ["Indicateur", "Unité"];
      const headerSub = ["", ""];
      periods.forEach((period) => {
        headerGroup.push(period.label, "", "");
        headerSub.push(`${year - 1}`, "Evol. N-1", `${year}`);
      });

      const rows = (table || []).map((row) => {
        const line = [row.name, row.unit || ""];
        for (let i = 0; i < periods.length * 3; i++) {
          const value = row.data ? row.data[i] : null;
          line.push(value === undefined ? null : value);
        }
        return line;
      });

      const aoa = [headerGroup, headerSub, ...rows];
      const workSheet = XLSX.utils.aoa_to_sheet(aoa);

      // Merge the two fixed columns vertically + each period label across 3 cols.
      const merges = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
        { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
      ];
      periods.forEach((period, idx) => {
        const startCol = 2 + idx * 3;
        merges.push({ s: { r: 0, c: startCol }, e: { r: 0, c: startCol + 2 } });
      });
      workSheet["!merges"] = merges;
      workSheet["!cols"] = [{ wch: 45 }, { wch: 10 }];

      XLSX.utils.book_append_sheet(workBook, workSheet, sheetTitles[tableIdx]);
    });

    XLSX.writeFile(
      workBook,
      `Statistiques Abeille ${year} - ${moment().format("DD-MM-YYYY")}.xlsx`
    );
  };

  render() {
    if (this.context.id) {
      return (
        <>
          <FadeIn>
            <Nav title="Statistiques spécifiques" className="mb-20" />

            <Card className="mb-20">
              <Row>
                <Col sm={12} md={3}>
                  <FormSelect
                    name="year"
                    value={this.state.year}
                    options={this.state.yearSelect}
                    title="Années"
                    onChange={this.handleSelectChange}
                    ignore={true}
                  />
                </Col>
                <Col sm={12} md={3}>
                  <FormSelect
                    name="group"
                    value={this.state.group}
                    options={this.state.groupSelect}
                    title="Expert"
                    onChange={this.handleSelectChange}
                    ignore={true}
                  />
                </Col>
                <Col sm={12} md={3} className="d-flex">
                  <Button
                    className="mt-auto"
                    text="Télécharger sur Excel"
                    onClick={this.exportExcel}
                    disabled={!this.state.data || this.state.data.length === 0}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </Button>
                </Col>
              </Row>
            </Card>

            <Card
              title="Qualité"
              className="mb-20"
              classNameChildren="overflow-x-auto"
            >
              <DataTable
                name="repairTime"
                data={
                  this.state.data &&
                  this.state.data.length > 0 &&
                  this.state.data[0]
                    ? this.state.data[0]
                    : null
                }
                year={this.state.year}
              />
              <DataTable
                name="totalLossTime"
                data={
                  this.state.data &&
                  this.state.data.length > 0 &&
                  this.state.data[1]
                    ? this.state.data[1]
                    : null
                }
                year={this.state.year}
              />
            </Card>

            {/* TECHNIQUE CARD */}
            <Card
              title="Technique (EAD + REP)"
              className="mb-20"
              classNameChildren="overflow-x-auto"
            >
              <DataTable
                name="technique"
                data={
                  this.state.data &&
                  this.state.data.length > 0 &&
                  this.state.data[2]
                    ? this.state.data[2]
                    : null
                }
                year={this.state.year}
              />
            </Card>

            {/* AVERAGE COST CARD */}
            <Card
              title="Coût Moyen"
              className="mb-20"
              classNameChildren="overflow-x-auto"
            >
              <DataTable
                name="avgCost"
                data={
                  this.state.data &&
                  this.state.data.length > 0 &&
                  this.state.data[3]
                    ? this.state.data[3]
                    : null
                }
                year={this.state.year}
              />
            </Card>
          </FadeIn>

          <Loader show={this.state.isLoad} />
        </>
      );
    } else {
      return <></>;
    }
  }
}
